var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTipoUsuario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.462,
    height: 16.591,
    viewBox: "0 0 23.462 16.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-6.069 -8.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_62",
    "data-name": "Caminho 62",
    d: "M12.047,20.556,9.058,22.085,6.069,20.556V17.542h5.978Z",
    transform: "translate(0 2.671)",
    fill: "#3aaaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_63",
    "data-name": "Caminho 63",
    d: "M8.363,17.542h2.989v3.014L8.363,22.085Z",
    transform: "translate(0.696 2.671)",
    fill: "#3a70f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_64",
    "data-name": "Caminho 64",
    d: "M9.059,19.428,6.07,17.9l2.989-1.529L12.048,17.9Z",
    transform: "translate(0 2.315)",
    fill: "#9bfcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_65",
    "data-name": "Caminho 65",
    d: "M8.363,19.428l2.989-1.53L8.363,16.369Z",
    transform: "translate(0.696 2.315)",
    fill: "#5cdafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_66",
    "data-name": "Caminho 66",
    d: "M18.753,20.573,15.764,22.1l-2.988-1.529V17.559h5.977Z",
    transform: "translate(2.036 2.676)",
    fill: "#ffcd13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_67",
    "data-name": "Caminho 67",
    d: "M15.069,17.559h2.989v3.014L15.069,22.1Z",
    transform: "translate(2.731 2.676)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_68",
    "data-name": "Caminho 68",
    d: "M15.765,19.445l-2.989-1.53,2.989-1.529,2.989,1.529Z",
    transform: "translate(2.036 2.32)",
    fill: "#fff7c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_69",
    "data-name": "Caminho 69",
    d: "M15.069,19.445l2.989-1.53-2.989-1.529Z",
    transform: "translate(2.731 2.32)",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_70",
    "data-name": "Caminho 70",
    d: "M25.46,20.589l-2.989,1.53-2.989-1.53V17.577H25.46Z",
    transform: "translate(4.071 2.682)",
    fill: "#f70057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_71",
    "data-name": "Caminho 71",
    d: "M21.776,17.577h2.988v3.012l-2.988,1.53Z",
    transform: "translate(4.767 2.682)",
    fill: "#bf0060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_72",
    "data-name": "Caminho 72",
    d: "M22.472,19.462l-2.989-1.529,2.989-1.53,2.988,1.53Z",
    transform: "translate(4.071 2.325)",
    fill: "#f17ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_73",
    "data-name": "Caminho 73",
    d: "M21.776,19.462l2.988-1.529L21.776,16.4Z",
    transform: "translate(4.767 2.325)",
    fill: "#ff5e90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_74",
    "data-name": "Caminho 74",
    d: "M8.363,16.162V14.741H25.846v1.421",
    transform: "translate(0.696 1.821)",
    fill: "none",
    stroke: "#025166",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_75",
    "data-name": "Caminho 75",
    d: "M14.034,10.226l1.349-1.485v9.242",
    transform: "translate(2.417 0)",
    fill: "none",
    stroke: "#025166",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_20",
    "data-name": "Linha 20",
    x1: 1.494,
    y1: 1.484,
    transform: "translate(17.801 8.741)",
    fill: "none",
    stroke: "#025166",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipoUsuario);
export default __webpack_public_path__ + "static/media/tipo-usuario.04eacf374ab933c5c601ac12041283a8.svg";
export { ForwardRef as ReactComponent };